import { render } from "./Image.vue?vue&type=template&id=bc4983e2"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc4983e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc4983e2', __exports__)) {
    api.reload('bc4983e2', __exports__)
  }
  
  module.hot.accept("./Image.vue?vue&type=template&id=bc4983e2", () => {
    api.rerender('bc4983e2', render)
  })

}


export default __exports__